export default __webpack_public_path__ + "static/media/P1000_Micropipette.45ea4d85.svg";